<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close.emit()">Avbryt</ion-button>
		</ion-buttons>
		<ion-title>Välj land</ion-title>
	</ion-toolbar>
	<ion-toolbar>
		<ion-searchbar placeholder="Sök land" #countryInput (ionInput)="onSearchbarInputChange($event)" />
	</ion-toolbar>
</ion-header>

<ion-content>
	<ion-list>
		@for (c of filteredCountries(); track c.code) {
		<ion-item (click)="selectCountry(c)" class="countryItem" [class.selected]="c.code === selectedCountry">
			<ion-label [class.bold]="c.code === selectedCountry">{{c.name}}</ion-label>
			<span slot="end" class="flag bg-{{ c.code | lowercase }}"></span>
		</ion-item>
		}
	</ion-list>
</ion-content>
